// solanaProvider.ts

import EventEmitter from 'events'
import { getDefaultStore } from 'jotai'
import { AnchorProvider } from '@coral-xyz/anchor'
import NodeWallet from '@coral-xyz/anchor/dist/cjs/nodewallet'
import { Connection, Keypair } from '@solana/web3.js'

import {
  DEFAULT_RPC_ENDPOINT,
  RPCEndpointKey,
  SUPPORT_RPC_ENDPOINT
} from '@/constants/settings'
import { rpcEndpointAtom } from '@/stores/settings'

type RpcEndpoint = {
  url: string
  ws?: string
  name?: string
  key?: string
  mev?: true
}

enum ProviderFactoryEvents {
  ON_ERROR = 'onError',
  ON_RECONNECT = 'onReconnect',
  ON_CHANGE = 'onChange'
}

class ProviderFactory {
  // private _rpcEndpoints: RpcEndpoint[]
  private _currentRpc: RpcEndpoint
  private _connection: Connection
  private _wallet: NodeWallet
  private _provider: AnchorProvider
  private _event: EventEmitter
  private _checkInterval: any = null
  private _checkTimer: any

  constructor(options: {
    endpoint: RpcEndpoint
    checkInterval?: number
    endpointOptional?: RpcEndpoint[]
  }) {
    this._event = new EventEmitter()
    // this._rpcEndpoints = options.endpointOptional || []
    this._checkInterval = options.checkInterval
    this._currentRpc = options.endpoint
    this._wallet = new NodeWallet(Keypair.generate())
    this._connection = this.createConnection(this._currentRpc)
    this._provider = new AnchorProvider(this._connection, this._wallet, {
      commitment: 'finalized'
    })

    // this.startConnectionChecker()
  }

  private createConnection(endpoint: RpcEndpoint) {
    return new Connection(endpoint.url, {
      commitment: 'confirmed',
      wsEndpoint: endpoint.ws || undefined
    })
  }

  // private startConnectionChecker() {
  //   // 每 30 秒检测一次 connection 是否存活（slot是否有变化）
  //   if (this._checkTimer) {
  //     clearInterval(this._checkTimer)
  //   }
  //   this._checkTimer = setInterval(async () => {
  //     try {
  //       const slot = await this._connection.getSlot()
  //       // console.log('Connection healthy, current slot:', slot)
  //     } catch (err) {
  //       // console.error('Connection failed, trying fallback RPC...')
  //       this._event.emit(ProviderFactoryEvents.ON_ERROR, err)
  //       // this.useBestRpc()
  //     }
  //   }, this._checkInterval)
  // }

  // private async useBestRpc() {
  //   // 轮询最快可用的RPC
  //   for (const endpoint of this._rpcEndpoints) {
  //     try {
  //       const conn = this.createConnection(endpoint)
  //       const slot = await conn.getSlot({ commitment: 'processed' })
  //       if (slot > 0) {
  //         this.switchRpc(endpoint)
  //         this._event.emit(ProviderEvents.ON_RECONNECT, endpoint)
  //         return
  //       }
  //     } catch (err) {
  //       continue
  //     }
  //   }
  //   console.error('No available RPC endpoints found!')
  // }

  public switchRpc(newRpc: RpcEndpoint) {
    console.log('Switching RPC endpoint to:', newRpc.url)
    this._currentRpc = newRpc
    this._connection = this.createConnection(newRpc)
    this._provider = new AnchorProvider(this._connection, this._wallet, {
      commitment: 'finalized'
    })
    this._event.emit(ProviderFactoryEvents.ON_CHANGE, newRpc)
  }

  public resetWallet() {
    console.log('Resetting wallet')
    this._wallet = new NodeWallet(Keypair.generate())
    this._provider = new AnchorProvider(this._connection, this._wallet, {
      commitment: 'finalized'
    })
  }

  public destroy() {
    if (this._checkTimer) {
      clearInterval(this._checkTimer)
    }
    // this._event.removeAllListeners()
    // this._provider.disconnect()
  }

  public get connection() {
    return this._connection
  }

  public get wallet() {
    return this._wallet
  }

  public get provider() {
    return this._provider
  }

  public get rpcEndpoint() {
    return this._currentRpc
  }

  public get event() {
    return this._event
  }
}

// 实例化ProviderFactory
const rpcEndpointStore = getDefaultStore().get(rpcEndpointAtom)
let rpcEndpoint
if (rpcEndpointStore) {
  rpcEndpoint = SUPPORT_RPC_ENDPOINT.find(
    (item) => item.url === rpcEndpointStore
  )
  if (!rpcEndpoint) {
    rpcEndpoint = SUPPORT_RPC_ENDPOINT.find(
      (item) => item.key === RPCEndpointKey.Custom
    )
    rpcEndpoint && (rpcEndpoint.url = rpcEndpointStore)
  }
} else {
  rpcEndpoint = DEFAULT_RPC_ENDPOINT
}
// console.log('rpcEndpoint', rpcEndpoint)
// const rpcEndpoint = (
//   SUPPORT_RPC_ENDPOINT.find((item)=> item.url === rpcEndpointStore)
//   || DEFAULT_RPC_ENDPOINT
// ) as RpcEndpoint
const solanaProvider = new ProviderFactory({
  endpoint: rpcEndpoint as RpcEndpoint
})

export {
  ProviderFactory,
  ProviderFactoryEvents,
  type RpcEndpoint,
  solanaProvider
}

// 单例暴露出去
// export const solanaManager = new ProviderManager(DEFAULT_RPC_ENDPOINT as RpcEndpoint)

// // 快捷方法
// export const getConnection = () => solanaManager.connection
// export const getProvider = () => solanaManager.provider
// export const getWallet = () => solanaManager.wallet

// // 支持外部主动切换RPC
// export const switchRpc = (newRpc: RpcEndpoint) => solanaManager.switchRpc(newRpc)

// // 支持外部重置Wallet
// export const resetWallet = () => solanaManager.resetWallet()

// class ProviderFactory {
//   private _rpcEndpoint: RpcEndpoint
//   private _connection: Connection
//   private _wallet: NodeWallet
//   private _provider: AnchorProvider
//   private _event: EventEmitter

//   constructor(initialEndpoint: RpcEndpoint) {
//     this._event = new EventEmitter();
//     this._rpcEndpoint = initialEndpoint
//     this._wallet = new NodeWallet(Keypair.generate())
//     this._connection = this.createConnection(initialEndpoint)
//     this._provider = new AnchorProvider(this._connection, this._wallet, {
//       commitment: 'finalized'
//     })
//   }

//   private createConnection(endpoint: RpcEndpoint) {
//     return new Connection(endpoint.url, {
//       commitment: 'confirmed',
//       wsEndpoint: endpoint.ws
//     })
//   }

//   // 切换到新的RPC地址
//   public switchRpc(newEndpoint: RpcEndpoint) {
//     console.log('Switching RPC endpoint to:', newEndpoint.url)
//     this._rpcEndpoint = newEndpoint
//     this._connection = this.createConnection(newEndpoint)
//     this._provider = new AnchorProvider(this._connection, this._wallet, {
//       commitment: 'finalized'
//     })
//   }

//   // 重置wallet
//   public resetWallet() {
//     console.log('Resetting wallet')
//     this._wallet = new NodeWallet(Keypair.generate())
//     this._provider = new AnchorProvider(this._connection, this._wallet, {
//       commitment: 'finalized'
//     })
//   }

//   public get connection() {
//     return this._connection
//   }

//   public get wallet() {
//     return this._wallet
//   }

//   public get provider() {
//     return this._provider
//   }

//   public get rpcEndpoint() {
//     return this._rpcEndpoint
//   }
// }
